/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { toggleAd } from 'state/actions/embedsState/embedManagementState/selected_embed_status';
// component
import AdsPage from 'pages/dashboard/embeds/management/ads/ads';



/* ========== ~~~~~~~~~~ EMBED ADs : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState, sessionStatus }) => ({
    currentStepPage: embedsState.embedManagementState.embedManagementStatus.currentStepPage,
    location: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.location,
    embedUUID: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.embedUUID,
    mocked: sessionStatus.mocked
});

// map actions
const mapDispatchToProps = dispatch => ({
	toggleAd: (adToToggle) => {
		dispatch(toggleAd(adToToggle))
    }
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AdsPage);
